import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IDdcFichier } from '../model/camp-fichier.model';
import { CampFichierCategorieEnum } from '../constant/enum';

@Injectable({
  providedIn: 'root'
})
export class DdcFileService {

  constructor(protected http: HttpClient) {
  }

  public resourceUrl = environment.apiServerUrl + 'ddc-fichiers';

  upload(formData: FormData): Observable<HttpResponse<IDdcFichier>> {
    return this.http.post<IDdcFichier>(this.resourceUrl, formData, {observe: 'response'});
  }

  getFilesByDdcIdAndDdcTypeAndCategorie(idDdc: number, typeDdc: string, categorie?: string, subCategorie?: string, idSiteContexteMarin?:number): Observable<HttpResponse<IDdcFichier[]>> {
    let query = `?idDdc=${idDdc}&typeDdc=${typeDdc}`;
    if(categorie){
      query += `&categorie=${categorie}`;
    }
    if(subCategorie) {
      query += `&subCategorie=${subCategorie}`;
    }
    if(idSiteContexteMarin) {
      query += `&idSiteContexteMarin=${idSiteContexteMarin}`;
    }
    return this.http.get<IDdcFichier[]>(`${this.resourceUrl}${query}`,  { observe: 'response' });
  }

  downloadFileByIdAndDdcType(id: number, typeDdc: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.resourceUrl}/download/${id}?typeDdc=${typeDdc}`, { responseType: 'blob' as 'json'});
  }

  deleteFileByIdAndDdcType(id: number, typeDdc: string): Observable<HttpResponse<IDdcFichier>> {
    return this.http.put<IDdcFichier>(`${this.resourceUrl}/delete/${id}/${typeDdc}`, {typeDdc: typeDdc}, {observe: 'response'});
  }

  generateDepartCampPdf(idCamp: number, categorie: CampFichierCategorieEnum): Observable<HttpResponse<IDdcFichier>> {
    return this.http.get<IDdcFichier>(`${this.resourceUrl}/generate-pdf?idCamp=${idCamp}&categorie=${categorie}`, { observe: 'response' });
  }

}
